<template>
  <a-drawer
    :visible="visible"
    placement="right"
    :closable="false"
    :destroy-on-close="true"
    width="480"
    @close="closeHandler"
  >
    <template #title>
      <div class="title">
        <IconFont
          type="iconfupanzongjie"
          class="icon"
        />
        {{ $t('weekly.outputDesc') }}
      </div>
    </template>
    <div class="container">
      <Content
        v-model:canClose="canClose"
        v-bind="$attrs"
        :objective-desc="objectiveDesc"
        :objective-id="objectiveId"
        :update-objective-description="updateObjectiveDescription"
        @cancel="cancelHandler"
      />
    </div>
  </a-drawer>
</template>
<script setup>
import { defineEmits, ref } from 'vue'
import Content from './content.vue'
const emit = defineEmits(['update:visible'])
defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  objectiveDesc: {
    type: String,
    default: '[]'
  },
  objectiveId: {
    type: Number,
    default: undefined
  },
  updateObjectiveDescription: {
    type: Function,
    default: () => {}
  }
})

const canClose = ref(true)
const closeHandler = () => {
  if (canClose.value) {
    emit('update:visible', false)
  }
}

const cancelHandler = () => {
  canClose.value = true
  emit('update:visible', false)
}
</script>
<style lang="less" scoped>
.title {
  display: flex;
  align-items: center;
  line-height: 32px;
}
.icon {
  margin-right: 8px;
}
.tip {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.56);
  margin-bottom: 4px;
  padding-left: 10px;
}
.tip-main {
  padding-bottom: 12px;
}

:deep(.ant-drawer-wrapper-body){
  .ant-drawer-header{
    position: sticky;
    top: 0;
  }
}

:deep(.ant-form-item-label){
  label {
    font-weight: 700;
  }
}

.container {
  padding-bottom: 46px;
}
</style>
